import { isAnalyticsGranted } from './cookieConsent';

const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

let gtagLoaded = false;
let gtagLoading = false;

const isEnabled = () => Boolean(MEASUREMENT_ID);

const clearGaCookies = () => {
  const hostname = window.location.hostname;
  const domains = ['', hostname, `.${hostname}`];

  document.cookie.split(';').forEach((cookie) => {
    const name = cookie.split('=')[0].trim();
    if (!name.startsWith('_ga')) {
      return;
    }
    domains.forEach((domain) => {
      const domainPart = domain ? `; domain=${domain}` : '';
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${domainPart}`;
    });
  });
};

const loadGtagScript = () => {
  if (!isEnabled() || gtagLoaded || gtagLoading) {
    return;
  }

  gtagLoading = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };

  window.gtag('consent', 'default', {
    analytics_storage: 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied'
  });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  script.onload = () => {
    gtagLoaded = true;
    gtagLoading = false;
    window.gtag('js', new Date());
    window.gtag('config', MEASUREMENT_ID, { send_page_view: false });
    applyConsentState();
  };
  script.onerror = () => {
    gtagLoading = false;
  };
  document.head.appendChild(script);
};

export const applyConsentState = () => {
  if (!isEnabled()) {
    return;
  }

  const granted = isAnalyticsGranted();

  if (granted) {
    loadGtagScript();
    if (!window.gtag) {
      return;
    }
    window.gtag('consent', 'update', {
      analytics_storage: 'granted',
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied'
    });
    return;
  }

  if (!window.gtag) {
    return;
  }

  window.gtag('consent', 'update', {
    analytics_storage: 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied'
  });
  clearGaCookies();
};

export const initAnalytics = () => {
  if (!isEnabled() || !isAnalyticsGranted()) {
    return;
  }
  loadGtagScript();
};

export const trackPageView = (path) => {
  if (!isEnabled() || !isAnalyticsGranted() || !window.gtag) {
    return;
  }
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title
  });
};
